import { render, staticRenderFns } from "./CompanyItem.vue?vue&type=template&id=9b434da0&scoped=true"
import script from "./CompanyItem.vue?vue&type=script&lang=js"
export * from "./CompanyItem.vue?vue&type=script&lang=js"
import style0 from "./CompanyItem.vue?vue&type=style&index=0&id=9b434da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b434da0",
  null
  
)

export default component.exports